import React from 'react';
import { useNavigate } from 'react-router-dom';

// Pages members can mention with @Name in posts, comments and messages.
// Keys are lowercase; the member can type any capitalization.
export const SIRATI_MENTIONS = {
  library: { path: '/library', label: 'Library' },
  calendar: { path: '/calendar', label: 'Calendar' },
  events: { path: '/calendar', label: 'Events' },
  quiz: { path: '/marriage-readiness-quiz', label: 'Quiz' },
  marriagequiz: { path: '/marriage-readiness-quiz', label: 'MarriageQuiz' },
  wifey: { path: '/wifey-application-builder', label: 'Wifey' },
  wifeybuilder: { path: '/wifey-application-builder', label: 'WifeyBuilder' },
  siratiplus: { path: '/premium', label: 'SiratiPlus' },
  dashboard: { path: '/dashboard', label: 'Dashboard' },
  mentors: { path: '/mentors', label: 'Mentors' },
  badges: { path: '/badges', label: 'Badges' },
  about: { path: '/about', label: 'About' },
  knowyourself: { path: '/spaces/know-yourself', label: 'KnowYourself' },
};

// Either a Sirati address (with or without https://) or an @Name.
const TOKEN = /(?:https?:\/\/)?(?:www\.)?sirati\.co(?:[/?#][^\s]*)?|@[A-Za-z]+/gi;
const TRAILING_PUNCTUATION = /[.,;:!?)\]'"’”]+$/;

const SiratiLink = ({ path, children }) => {
  const navigate = useNavigate();
  const onClick = (e) => {
    // Let ctrl/cmd/middle-click open a new tab as usual
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    navigate(path);
  };
  return (
    <a
      href={path}
      onClick={onClick}
      className="text-primary font-medium underline underline-offset-2 hover:text-primary-dark break-words"
    >
      {children}
    </a>
  );
};

// Turns @Library and sirati.co addresses inside plain text into in-app links.
// Only Sirati addresses are linked; any other address stays plain text.
// Returns the original string when there is nothing to link.
export const linkifySirati = (text) => {
  if (!text || typeof text !== 'string' || (!text.includes('@') && !/sirati\.co/i.test(text))) return text;
  const out = [];
  let last = 0;
  let n = 0;
  for (const m of text.matchAll(TOKEN)) {
    let token = m[0];
    const start = m.index;
    const before = start > 0 ? text[start - 1] : '';
    // Skip email addresses (salam@sirati.co), words that merely end in sirati.co, and the like
    if (/[\w.@/-]/.test(before)) continue;

    let path = null;
    if (token[0] === '@') {
      const entry = SIRATI_MENTIONS[token.slice(1).toLowerCase()];
      if (!entry) continue;
      path = entry.path;
    } else {
      token = token.replace(TRAILING_PUNCTUATION, '');
      try {
        const url = new URL(/^https?:\/\//i.test(token) ? token : `https://${token}`);
        path = `${url.pathname || '/'}${url.search}${url.hash}`;
      } catch (e) {
        continue;
      }
    }
    if (start > last) out.push(text.slice(last, start));
    out.push(<SiratiLink key={`sl${n++}`} path={path}>{token}</SiratiLink>);
    last = start + token.length;
  }
  if (out.length === 0) return text;
  if (last < text.length) out.push(text.slice(last));
  return out;
};
